import { CheckCircleIcon, WarningIcon, InfoIcon } from '@/components/ui/Icons';

export const PLANNER_STATES = new Set(['Добавлен', 'Запись']);

export type PlannerStatusSeverity = 'error' | 'warning' | 'success' | 'info';

/** Статусы планера у названия: «Опасный» и «Критический» */
export function isPlannerCriticalOrDangerStatus(status: string): boolean {
  return status === 'critical' || status === 'danger';
}

export function getPlannerStatusInfo(status: string): {
  label: string;
  icon: React.ComponentType<{ size?: number }>;
  severity: PlannerStatusSeverity;
  badgeBg: string;
  badgeColor: string;
} {
  switch (status) {
    case 'critical':
      return {
        label: 'Критический',
        icon: WarningIcon,
        severity: 'error',
        badgeBg: 'color-mix(in srgb, var(--accent-error) 15%, transparent)',
        badgeColor: 'var(--accent-error)',
      };
    case 'danger':
      return {
        label: 'Опасный',
        icon: WarningIcon,
        severity: 'warning',
        badgeBg: 'color-mix(in srgb, var(--accent-warning) 15%, transparent)',
        badgeColor: 'var(--accent-warning)',
      };
    case 'attention':
      return {
        label: 'Внимание',
        icon: InfoIcon,
        severity: 'warning',
        badgeBg: 'color-mix(in srgb, var(--accent-warning) 15%, transparent)',
        badgeColor: 'var(--accent-warning)',
      };
    case 'warning':
      return {
        label: 'Предупреждение',
        icon: InfoIcon,
        severity: 'info',
        badgeBg: 'color-mix(in srgb, var(--accent) 15%, transparent)',
        badgeColor: 'var(--accent)',
      };
    default:
      return {
        label: 'В порядке',
        icon: CheckCircleIcon,
        severity: 'success',
        badgeBg: 'color-mix(in srgb, var(--accent-success) 15%, transparent)',
        badgeColor: 'var(--accent-success)',
      };
  }
}